import axios from "axios";
import businessUnit from "../../models/unidadDeNegocios/businessUnit";
import tableAccessCode from "../../models/unidadDeNegocios/tableAccessCode"
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getBusinessUnits() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/unnegocios`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return businessUnit.fromJson(item);
        })
      );
  }

  getBusinessUnitId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/unnegocios/${id}`, { headers })
      .then(({ data }) => data);
  }


  addBusinessUnit(payload) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };


    return axios.post(`${url}/unnegocios`, payload, { headers });
  }

  editBusinessUnit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre
    }
    return axios
      .patch(`${url}/unnegocios/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });

  }

  deleteBusinessUnit(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/unnegocios/${id}`, { headers });
  }
  ////relaciones/////

  //    Unidad de negocio - Operador
  addOperatorToBusinessUnit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = { ...data };

    if (payload && payload.operName) {
      delete payload.operName;
    }

    return axios.post(`${url}/unnegocios/operadores`, payload, { headers });
  }


  editOperatorToBusinessUnit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {}

    if ('def' in data) {
      payload.def = data.def;
    }

    if (data.dateStartInput !== undefined) {
      payload.fecDesde = data.dateStartInput + "T00:00:00.000Z"
    }

    if (data.dateEndInput !== undefined) {
      payload.fecHasta = data.dateEndInput + "T00:00:00.000Z"
    }

    return axios
      .patch(`${url}/unnegocios/operadores/${data.unNegocioId}&${data.operId}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteBusinessUnitToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/unnegocios/operadores/${data.unNegocioId}&${data.operId}`, { headers });
  }
  
  //Unidades de negocios - Tabla
  getTables() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/unnegocios/tablas`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return businessUnit.fromJson(item);
        })
      );
  }

  addTableToBusinessUnit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = data

    return axios.post(`${url}/unnegocios/tablas`, payload, { headers });
  }


  editTableToBusinessUnit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {}

    if ('def' in data) {
      payload.def = data.def;
    }

    if ('cat' in data) {
      payload.cat = data.cat;
    }


    return axios
      .patch(`${url}/unnegocios/tabla/${data.unNegocioId}&${data.nameTable}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteTableToBusinessUnit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/unnegocios/tablas/${data.unNegocioId}&${data.name}`, { headers });
  }

  //Unidades de negocios get cats
  getCats() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/cats`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return tableAccessCode.fromJson(item);
        })
      );
  }

}
export default service;